<template>
  <div
    class="modal"
    @click.self="handleCancel">
    <div class="modal__popup">
      <p v-html="message"/>

      <div class="btn__group">
        <Btn
          :label="'キャンセル'"
          :color="'gray'"
          class="cancel"
          @click.native="handleCancel"/>
        <Btn
          :label="nameAction"
          :color="'red'"
          @click.native="handleAction"/>
      </div>
    </div>
  </div>
</template>

<script>
import Btn from '@/components/parts/Btn'

export default {
  name: 'ModalConfirm',

  components: {
    Btn
  },

  props: {
    message: {
      type: String,
      default: ''
    },

    nameAction: {
      type: String,
      default: ''
    }
  },

  methods: {
    handleCancel (event) {
      this.$emit('cancel', event)
    },

    handleAction (event) {
      this.$emit('action', event)
    }
  }
}
</script>

<style lang="postcss" scoped>
  @import '../assets/css/modal.pcss';
  .modal__popup {
    width: 360px;
  }
  p {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    line-height: 31px;
    text-align: center;
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalConfirm.vue